/**
 * /bulk-imports/new?type=… (switching-and-first-payroll §4): the payroll
 * guide deep-links straight to the employees or "pay given this year"
 * import. An unknown value is ignored (the wizard's default stays).
 */

import { BULK_IMPORT_TYPES, type BulkImportType } from "@/types/bulk-import";

export interface ImportTypeSearch {
  type?: BulkImportType;
}

export function parseImportTypeSearch(search: Record<string, unknown>): ImportTypeSearch {
  const t = search.type;
  return typeof t === "string" && (BULK_IMPORT_TYPES as readonly string[]).includes(t)
    ? { type: t as BulkImportType }
    : {};
}
